module.exports = __webpack_public_path__ + "static/media/practice_version_1.1.8dfce236.png";